import { Reveal, Eyebrow } from "../components/Reveal";

const HEARD = [
  "“Your reports are normal.”",
  "“You just need to lose weight.”",
  "“It's your thyroid.”",
  "“It's stress.”",
  "“Take this supplement.”",
  "“Exercise more.”",
];

export const Checklist = () => (
  <section className="bg-white" data-testid="checklist-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow>01 · The problem with fragments</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Your health isn&rsquo;t a checklist.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-inkmuted leading-relaxed">
            But health rarely fits neatly into one diagnosis. At InSight Metabolics, we look at the individual
            behind the numbers.
          </p>
          <p className="mt-5 text-inkmuted leading-relaxed">
            We consider metabolic health, nutrition, movement, sleep, stress, clinical history and laboratory
            patterns to understand what may be contributing to your concerns&mdash;and, importantly, what can
            realistically be changed.
          </p>
          <p className="mt-8 font-serif italic text-2xl text-gold">
            Personalised. Measurable. Practical.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <p className="text-sm text-inkmuted mb-6">You may have been told:</p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-line border border-line">
          {HEARD.map((q, i) => (
            <Reveal key={q} delay={0.08 * i} className="bg-white">
              <div className="p-7 sm:p-9 h-full hover:bg-paper transition-colors duration-500">
                <span className="font-mono text-[10px] tracking-[0.22em] text-gold">0{i + 1}</span>
                <p className="mt-3 font-serif italic text-xl sm:text-2xl text-ink leading-snug">{q}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
